import DPR from './DPR.js'

export default class SizeLabel {
  constructor() {
    this._elLabel = document.querySelector('#sizeLabel');
    this._elWidth = this._elLabel.querySelector('.width');
    this._elHeight = this._elLabel.querySelector('.height');
  }
  update(cursorX, cursorY, shownW, shownH) {
    this._elWidth.textContent = shownW;
    this._elHeight.textContent = shownH;
    this._elLabel.style.left = DPR.div(cursorX) + 'px';
    this._elLabel.style.top = DPR.div(cursorY) + 'px';
  }
  show() {
    this._elLabel.classList.remove('hidden');
  }
  hide() {
    this._elLabel.classList.add('hidden');
  }
}
